import { useState } from 'react';

import _isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';

import { INTERNAL_PAGE_TYPE } from 'components/modules/pages/constants';
import { filterPagesByType } from 'components/modules/pages/services/pages';
import { selectWebsitePages } from 'selectors/website';

import { updateWebsitePages } from '../../../../../actions/website';
import API from '../../../../../libs/api';
import { objectToCamelCase } from '../../../../../libs/format';
import { selectWebsite } from '../../../../../selectors/website';
import useAsyncEffect from '../../../foundation/hooks/use-async-effect';
import useFetch from '../../../foundation/hooks/use-fetch/use-fetch';

export default function usePages({
  fetchPagesOnMount = true,
  fetchRecipeSettingsOnMount = true,
} = {}) {
  const website = useSelector(selectWebsite);

  const dispatch = useDispatch();

  const pages = useSelector(selectWebsitePages);
  const internalPages = filterPagesByType(pages, INTERNAL_PAGE_TYPE);
  const [settings, setSettings] = useState([]);

  const { fetching: loading, fetch, withFetch } = useFetch();

  const { id: websiteId } = website;

  async function fetchPages() {
    const { data } = await API.getPages(websiteId);
    dispatch(updateWebsitePages(data));
  }

  async function fetchPagesSettings() {
    const { data } = await API.getWebsiteRecipe(website.id);
    const { component_configuration_settings: configurationSettings } = data;
    setSettings(objectToCamelCase(configurationSettings));
  }

  useAsyncEffect(async () => {
    let asyncFunctions = [];

    if (fetchPagesOnMount) {
      asyncFunctions = [...asyncFunctions, fetchPages];
    }

    if (fetchRecipeSettingsOnMount) {
      asyncFunctions = [...asyncFunctions, fetchPagesSettings];
    }

    if (!_isEmpty(asyncFunctions)) {
      await fetch(asyncFunctions, { throwError: false });
    }
  }, [websiteId, fetchPagesOnMount, fetchRecipeSettingsOnMount]);

  return {
    pages,
    internalPages,
    settings,
    loading,
    refreshPages: withFetch(fetchPages, { throwError: false }),
    refreshSettings: withFetch(fetchPagesSettings, { throwError: false }),
  };
}
